<template>
  <div class="home-registration">
    <div style="text-align: center; font-weight: 600; font-size: 20px">
      {{$t('Home.Home.Register.Description')}}
    </div>
    <div style="">
      <slot />
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.home-registration {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

</style>
